import React from 'react';
import PublicNavbar from '../components/layout/PublicNavbar';

const Opportunities = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <PublicNavbar />
      <div className="pt-24 pb-12">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl font-bold text-gray-900 mb-8">Career Opportunities</h1>
            
            <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Featured Positions</h2>
              <p className="text-gray-600 mb-6">
                Explore exciting career opportunities available exclusively to our alumni community. These positions are carefully curated to match the skills and expertise of our members.
              </p>
              
              <div className="space-y-6">
                <div className="border border-gray-200 rounded-lg p-6">
                  <h3 className="text-xl font-semibold text-gray-800 mb-2">Senior Software Engineer</h3>
                  <p className="text-gray-600 mb-4">Leading Tech Company • Remote</p>
                  <p className="text-gray-600 mb-4">
                    Join our team to work on cutting-edge projects and help shape the future of technology.
                  </p>
                  <button className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition duration-300">
                    Learn More
                  </button>
                </div>
                
                <div className="border border-gray-200 rounded-lg p-6">
                  <h3 className="text-xl font-semibold text-gray-800 mb-2">Product Manager</h3>
                  <p className="text-gray-600 mb-4">Innovative Startup • Hybrid</p>
                  <p className="text-gray-600 mb-4">
                    Lead product development and drive innovation in a fast-paced environment.
                  </p>
                  <button className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition duration-300">
                    Learn More
                  </button>
                </div>
                
                <div className="border border-gray-200 rounded-lg p-6">
                  <h3 className="text-xl font-semibold text-gray-800 mb-2">Data Scientist</h3>
                  <p className="text-gray-600 mb-4">Enterprise Solutions • On-site</p>
                  <p className="text-gray-600 mb-4">
                    Work with big data and machine learning to solve complex business problems.
                  </p>
                  <button className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition duration-300">
                    Learn More
                  </button>
                </div>
              </div>
            </div>
            
            <div className="bg-white rounded-lg shadow-lg p-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">How to Apply</h2>
              <p className="text-gray-600 mb-6">
                To access these opportunities and more:
              </p>
              <ol className="list-decimal list-inside text-gray-600 mb-6 space-y-2">
                <li>Create an account or log in to your existing account</li>
                <li>Complete your profile with your skills and experience</li>
                <li>Browse available positions and apply directly through our platform</li>
                <li>Get notified about new opportunities matching your profile</li>
              </ol>
              <div className="flex space-x-4">
                <button className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition duration-300">
                  Sign Up
                </button>
                <button className="bg-white text-blue-600 border border-blue-600 px-6 py-2 rounded-lg hover:bg-blue-50 transition duration-300">
                  Log In
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Opportunities; 